// @mui
import Container from '@mui/material/Container';
// hooks
// _mock
// components
import { useSettingsContext } from 'src/components/settings';
import CostCodesTable from './costCodes-table';
// assets
//

// ----------------------------------------------------------------------

export default function CostCodes() {
    // const { user } = useMockedUser();
    const settings = useSettingsContext();
    return (
        <Container maxWidth={ settings.themeStretch ? false : 'xl' }>
            <CostCodesTable />
        </Container >
    );
}
